import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type {
    AppsSearchRequestDto,
    AppsSearchResponseDto,
} from "app/pages/sales-intelligence/modules/apps-search/types/dto";
import { selectIsLeadsSearchDtoReady } from "app/pages/sales-intelligence/modules/leads-search";

import { createAppsSearchResultsQuery } from "./options";

export function useAppsSearchResultsQuery<T = AppsSearchResponseDto>(
    dto: AppsSearchRequestDto,
    select?: (data: AppsSearchResponseDto) => T,
) {
    const isLeadsSearchDtoReady = useSelector(selectIsLeadsSearchDtoReady);

    return useQuery(createAppsSearchResultsQuery(dto, isLeadsSearchDtoReady, select));
}
